export default __webpack_public_path__ + "static/footerBanner-be47a528c0d75413480b6630849dd6a4.webp";